function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M7 256h43c0 114 92 206 206 206s206-92 206-206S370 50 256 50V7c137 0 249 112 249 249S393 505 256 505 7 393 7 256zm202 70V186c0-13 14-20 24-13l102 71c8 6 8 18 0 24l-102 71c-10 7-24 0-24-13z"
})));